/* eslint-disable import/no-duplicates */
import fb from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

// Unified Firebase backend: Both production and dev/staging use shotlist-dev
// Environment separation is maintained through URL routing (productionDomains array)
// Production URL: app.creativequeue.io
// Dev/staging URLs: All other domains
fb.initializeApp({
  apiKey: 'AIzaSyCKjEfc5JDezLDFm3OWCVwwVadleBV-s8I',
  authDomain: 'shotlist-dev.firebaseapp.com',
  projectId: 'shotlist-dev',
  storageBucket: 'shotlist-dev.appspot.com',
  messagingSenderId: '296840654953',
  appId: '1:296840654953:web:77fe49e1538238466932f8',
  measurementId: 'G-1TZ6P7GNBH',
});

export const firebase = fb;
const app = fb.app();
export const auth = fb.auth();
export const { firestore } = fb;
export const db = fb.firestore();
export const fn = app.functions('us-central1');
export const { FieldValue } = fb.firestore;
export const BATCH_MAX = 500;

if (window.location.hostname === 'localhost' && import.meta.env.VITE_DISABLE_EMULATORS !== 'true') {
  auth.useEmulator('http://localhost:9099');
  db.useEmulator('localhost', 8001);
  fn.useEmulator('localhost', 5001);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).fb = firebase;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).auth = auth;
